import { render, staticRenderFns } from "./Cities.vue?vue&type=template&id=028c4668&scoped=true&"
import script from "./Cities.vue?vue&type=script&lang=js&"
export * from "./Cities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c4668",
  null
  
)

export default component.exports